@reference "@glow/tailwind-config/reference.css";

.group {
  @apply grid;
}

/* The selected border is the 1px border plus a 1px inset shadow, so the size does not shift between
   states. Neighbours overlap by a pixel so the shared edge stays 1px. */
.button {
  @apply px-4;
  @apply border;
  @apply border-solid;
  @apply border-gray-500;
  @apply bg-white;
  @apply text-emphasis-medium;
  @apply whitespace-nowrap;
  @apply cursor-pointer;
}

.button:first-child {
  @apply rounded-l-sm;
}

.button:last-child {
  @apply rounded-r-sm;
}

.button:not(:last-child) {
  @apply -mr-px;
}

.lg {
  @apply h-10;
  @apply text-base;
}

.sm {
  @apply h-8;
  @apply text-sm;
}

.button[aria-pressed="true"] {
  @apply relative;
  @apply border-primary-500;
  @apply bg-primary-100;
  @apply text-primary-500;
  @apply font-semibold;
  box-shadow: inset 0 0 0 1px var(--color-primary-500);
}

.button:hover:not([aria-pressed="true"]) {
  @apply bg-gray-100;
}
